export const transitionsList = [
  {
    id: 'slideLeft',
    name: 'Slide from left to right',
    category: 'Slide',
  },
  {
    id: 'slideRight',
    name: 'Slide from right to left',
    category: 'Slide',
  },
  {
    id: 'slideTop',
    name: 'Slide from top to bottom',
    category: 'Slide',
  },
  {
    id: 'slideBottom',
    name: 'Slide from bottom to top',
    category: 'Slide',
  },
  {
    id: 'tileLeft',
    name: 'Slide from left to right',
    category: 'Tile',
  },
  {
    id: 'tileRight',
    name: 'Slide from right to left',
    category: 'Tile',
  },
  {
    id: 'tileTop',
    name: 'Slide from top to bottom',
    category: 'Tile',
  },
  {
    id: 'tileBottom',
    name: 'Slide from bottom to top',
    category: 'Tile',
  },
  {
    id: 'fade',
    name: 'Fade in/out',
    category: 'Fade',
  },
  {
    id: 'rippleCircle',
    name: 'Ripple circle',
    category: 'Ripple',
  },
  {
    id: 'spriteInk',
    name: 'Ink',
    category: 'Spritesheet',
  },
];
